import React from 'react';
import Header from './Header';
import Footer from './Footer';

/** App shell applied to every marketing page. */
const Layout = ({ children }) => (
  <div className="ss-marketing">
    <Header />
    <main>{children}</main>
    <Footer />
  </div>
);

export default Layout;
